module.exports = __webpack_public_path__ + "img/cleaner.1d20b892.svg";